<template>
    <div>
        <!--   START   -->
        <spinner v-if="isLoading"> </spinner>

        <div v-if="jobs !== null && isLoading === false">
            <div class="timeline">
                <div class="timeline-month">
                    {{ this.dateOfNow|dateFormat('MMMM, YYYY') }}
                    <span>{{jobs.length }} {{'Jobs'|trans}}</span>
                </div>

                <div class="timeline-section" v-for="jobRelated in jobs">
                    <div class="timeline-date">
                        {{jobRelated.dateJobStart|dateFormat('YYYY-MM-DD HH:mm')}}
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="timeline-box">
                                <div class="box-title">
                                    <i class="fa fa-asterisk" aria-hidden="true"></i> #{{ jobRelated.id|TruncateJobNumber }} {{jobRelated.interventionType }}
                                </div>
                                <div class="box-content">

                                    <div class="box-item"><strong>{{'Description'|trans}}</strong> {{jobRelated.jobDescription}}</div>
                                    <div class="box-item">
                                        <strong>{{'Account infos'|trans}}</strong><br>
                                        <span>{{'Pieces'|trans}} : {{jobRelated.account.pieces|Round}}{{ $currency.symbol(user.country)}}</span><br>
                                        <span>{{'Price'|trans}} : {{jobRelated.account.price|Round}}{{ $currency.symbol(user.country)}}</span><br>
                                        <span>{{'Paid'|trans}} : {{jobRelated.account.paid|Round}}{{ $currency.symbol(user.country)}}</span><br>
                                    </div>
                                </div>

                                <div class="box-content" v-if="jobRelated.documents.length > 0">
                                    <div class="box-item">{{'Documents'|trans}}</div>
                                    <div class="box-item">
                                        <ul class="list-group">
                                            <li v-for="document in jobRelated.documents" class="list-group-item" >
                                                <button @click="document.isOpen = !document.isOpen">{{'Show'|trans}} {{document.documentType}} #{{document.id}}</button>
                                                <div v-if="document.isOpen">
                                                    <br>
                                                    <a :href="getInvoicePath(document.id)" target="_blank">
                                                        <button>{{'Download'|trans}} <i class="fa fa-download"></i></button>
                                                    </a>
                                                    <hr>
                                                    <div class="private_note" v-html="prettyLog(document.privateNote)"> </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <hr>
                                </div>

                                <div class="box-footer"></div>
                            </div>
                        </div>
                    </div>

<!--                    {{ job. }}-->

                </div>

            </div>
        </div>

        <!--        ENDS -->
    </div>
</template>

<script>
	import Spinner from "../Spinner";
	import Routing from '../../backend-router';
	export default {
		name : "historyJob",
		components: {Spinner},
		props: {
			job: Object,
            user:Object
		},
		data() {
			return {
                jobs : null,
                isLoading:false
			};
		},
        async created() {
		    await this.getJobHistoryAndRelated();
		},
		methods: {
			async getJobHistoryAndRelated(){
				this.isLoading = true;
				this.jobs = await this.$api.job.getJobHistoryAndRelated(this.job.id);
				this.isLoading = false;
            },
			getInvoicePath(documentId){
				return  process.env.VUE_APP_API_BASE_URL + Routing.generate('worker_interface_generate_pdf', {id: documentId, action : 'generate','with_voucher':false});
			},
			prettyLog(str){

				const regex = /(\[.*?\])(\[.*?\])/gm;

				let m;

				let tmpStr = str;

				while ((m = regex.exec(str)) !== null) {
					// This is necessary to avoid infinite loops with zero-width matches
					if (m.index === regex.lastIndex) {
						regex.lastIndex++;
					}

					// The result can be accessed through the `m`-variable.
					m.forEach((match, groupIndex) => {
						if(groupIndex === 0){
							tmpStr = tmpStr.replace(match, "<hr>\n <p class='log_private_note'>"+match+"</p>");
						}
					});
				}

				return tmpStr;
			},
		},
        computed:{
			dateOfNow(){
				return new Date();
            }
        },
        filters:{
			Round(value) {
				if(value !== null){
					return Math.round(value * 100) / 100;
				}
			},
			TruncateJobNumber(value) {
				return value.toString().substr(2, value.toString().length);
			},
        },
	}
</script>

<style>


    .timeline{
        margin-top:20px;
        position:relative;

    }

    .timeline:before{
        position:absolute;
        content:'';
        width:4px;
        height:calc(100% + 50px);
        background: rgb(202, 212, 220);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8a9196', endColorstr='#62696d',GradientType=1 );
        left:14px;
        top:5px;
        border-radius:4px;
    }

    .timeline-month{
        position:relative;
        padding:4px 15px 4px 35px;
        background-color:#f4f5f7;
        display:inline-block;
        width:auto;
        border-radius:40px;
        border:1px solid #e0e2e5;
        border-right-color:#d2d2d2;
        margin-bottom:30px;
    }

    .timeline-month span{
        position:absolute;
        top:-1px;
        left:calc(100% - 10px);
        z-index:-1;
        white-space:nowrap;
        display:inline-block;
        background-color:#111;
        padding:4px 10px 4px 20px;
        border-top-right-radius:40px;
        border-bottom-right-radius:40px;
        border:1px solid black;
        box-sizing:border-box;
    }

    .timeline-month:before{
        position:absolute;
        content:'';
        width:18px;
        height:18px;
        background: rgb(157, 227, 44);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8a9196', endColorstr='#70787d',GradientType=0 );
        border-radius:100%;
        border:1px solid rgb(123, 189, 20);
        left:5px;
    }

    .timeline-section{
        padding-left:24px;
        display:block;
        position:relative;
        margin-bottom:30px;
    }

    .timeline-date{
        margin-bottom:15px;
        padding:2px 15px;
        background-color: #f4f5f7;
        position:relative;
        display:inline-block;
        border-radius:20px;
        border:1px solid #d6d6d6;
        color: #323232;
        /*text-shadow:1px 1px 1px rgba(0,0,0,0.3);*/
    }
    .timeline-section:before{
        content:'';
        position:absolute;
        width:30px;
        height:1px;
        background-color:#d6d6d6;
        top:12px;
        left:20px;
    }

    .timeline-section:after{
        content:'';
        position:absolute;
        width:10px;
        height:10px;
        background-color: #d6d6d6;
        top:7px;
        left:11px;
        border:1px solid #8f9ca8;
        border-radius:100%;
    }

    .timeline-section .col-sm-4{
        margin-bottom:15px;
    }

    .timeline-box{
        position:relative;

        background-color: #f4f5f7;
        border-radius:4px;
        border:1px solid #dad9d9;
        transition:all 0.3s ease;
        overflow:hidden;
    }

    .box-icon{
        position:absolute;
        right:5px;
        top:0px;
    }

    .box-title{
        padding:5px 15px;
        border-bottom: 1px solid #d5e0e8;
    }

    .box-title i{
        margin-right:5px;
    }

    .box-content{
        padding:5px 15px;
        background-color:#d5e0e8;
    }

    .box-content strong{
        color:#666;
        font-style:italic;
        margin-right:5px;
    }

    .box-item{
        margin-bottom:5px;
    }

    .box-footer{
        padding:5px 15px;
        border-top: 1px solid #b8c1c8;
        background-color:#b8c1c8;
        text-align:right;
        font-style:italic;
    }

    .private_note{
        max-height: 100px;
        overflow-y: scroll;
        background: #eef9da;
        padding:8px;
    }

    .private_note hr{
        margin:0px;
    }


</style>
